<template>
<div class="task-panel">
  <a href="#" class="small d-inline-block mb-2" @click.prevent="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</a>
  <b-card no-body>
    <b-card-body>
      <h4 class="mb-3">{{ title }}</h4>
      <slot></slot>
    </b-card-body>
    <b-card-footer v-if="$slots.actions || $scopedSlots.actions" class="bg-white text-right">
      <a href="#" class="mr-3 small" @click.prevent="$emit('back')">Cancel</a>
      <slot name="actions"></slot>
    </b-card-footer>
  </b-card>
</div>
</template>

<script>
// A focused single-task screen with a back link and a footer for its main button.
export default {
  props: { title: String }
}
</script>
